<mat-form-field>
  <!-- Input for short text -->
  <input
    *ngIf="!isLongText"
    [(ngModel)]="question.answer!.value"
    matInput=""
    [attr.inputmode]="inputMode"
    [attr.autocomplete]="autocomplete"
    [disabled]="kycLocked || (autofillMode && !autofillEditable && !!question.answer!.value)"
    placeholder="{{ 'Insert here' | translate }}"
    [required]="question.elective === false"
    (input)="validateAndEmit()"
    (blur)="onBlur()"
  />

  <!-- Textarea for long text -->
  <textarea
    *ngIf="isLongText"
    [(ngModel)]="question.answer!.value"
    matInput=""
    [attr.autocomplete]="autocomplete"
    [disabled]="kycLocked || (autofillMode && !autofillEditable && !!question.answer!.value)"
    cdkTextareaAutosize=""
    placeholder="{{ 'Insert here' | translate }}"
    [required]="question.elective === false"
    (input)="validateAndEmit()"
    (blur)="onBlur()"
    #autosize="cdkTextareaAutosize"
    cdkAutosizeMinRows="2"
    cdkAutosizeMaxRows="5"
  ></textarea>

  <!-- Error message for validation -->
  <!-- <mat-error *ngIf="!question.isValid">
    {{ question.messageError || "Invalid" }}
  </mat-error> -->
</mat-form-field>
